/* Hajra & Co  Theme JS */

document.addEventListener('DOMContentLoaded', () => {
  initScrollAnimations();
  initAccordions();
  initHeader();
  initMobileMenu();
  initStickyATC();
});

/* ─── Scroll-triggered animations ─── */
function initScrollAnimations() {
  const els = document.querySelectorAll('[data-animate]');
  if (!els.length) return;

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const delay = entry.target.dataset.delay || 0;
          setTimeout(() => entry.target.classList.add('is-visible'), delay);
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  els.forEach((el) => io.observe(el));
}

/* ─── Accordion ─── */
function initAccordions() {
  document.querySelectorAll('.accordion-trigger').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion-item');
      const isOpen = item.classList.contains('is-open');

      // Close siblings in same group
      const group = item.closest('.accordion-group');
      if (group) {
        group.querySelectorAll('.accordion-item.is-open').forEach((open) => {
          if (open !== item) open.classList.remove('is-open');
        });
      }

      item.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });
  });
}

/* ─── Sticky header ─── */
function initHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  let lastY = 0;
  let ticking = false;

  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        const y = window.scrollY;
        header.classList.toggle('is-scrolled', y > 60);
        header.classList.toggle('is-hidden', y > lastY && y > 200);
        lastY = y;
        ticking = false;
      });
      ticking = true;
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
}

/* ─── Mobile menu ─── */
function initMobileMenu() {
  const toggle = document.querySelector('.nav-toggle');
  const menu   = document.querySelector('.nav-drawer');
  if (!toggle || !menu) return;

  toggle.addEventListener('click', () => {
    const open = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('menu-open', open);
  });

  // Close on overlay click
  menu.addEventListener('click', (e) => {
    if (e.target === menu) {
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
    }
  });
}
/* ─── Newsletter forms (footer + popup) ─── */

document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-newsletter-submit]');
  if (!btn) return;

  const wrap = btn.closest('[data-newsletter-form]');
  if (!wrap) return;

  const form = wrap.closest('form');
  if (!form) return;

  form.requestSubmit();
});

document.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter') return;

  const wrap = e.target.closest('[data-newsletter-form]');
  if (!wrap) return;

  e.preventDefault();

  const form = wrap.closest('form');
  if (!form) return;

  form.requestSubmit();
});

/* ─── Contact form ─── */
document.addEventListener('submit', (e) => {
  const form = e.target.closest('[data-contact-form]');
  if (!form) return;

  // Shopify handles the actual submission via action="/contact"
  // This is for client-side UI feedback only
  const btn = form.querySelector('button[type="submit"]');
  if (btn) {
    btn.textContent = 'Sending…';
    btn.disabled = true;
  }
});

/* ─── Sticky mobile ATC ─── */
function initStickyATC() {
  const sticky = document.getElementById('sticky-atc');
  const primaryBtn = document.querySelector('.product-atc');
  if (!sticky || !primaryBtn) return;

  const io = new IntersectionObserver(
    (entries) => {
      const visible = entries[0].isIntersecting;
      sticky.classList.toggle('is-visible', !visible);
      sticky.setAttribute('aria-hidden', String(visible));
    },
    { threshold: 0, rootMargin: '0px 0px -20px 0px' }
  );

  io.observe(primaryBtn);
}

/* ─── Utility: debounce ─── */
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), wait);
  };
}
